/*
 * @Author: panweikang
 * @Date: 2024-01-03 13:31:10
 * @LastEditTime: 2024-01-12 08:48:14
 * @Description:
 */

import { Footer, Divider, ImageViewer } from 'antd-mobile'
import { DownOutline } from 'antd-mobile-icons'
import { useEffect } from 'react'
import { useState } from 'react'
import ixuanzhiPng from '../../../src/static/footer/ixuanzhi.png'
import logoPng from '../../../src/static/footer/logo.png'
import qrcodePng from '../../../src/static/footer/qrcode.png'
import { jsConfigApi } from '../../api/yearEndReportApi'
import './index.scss'
// import wxConfig from '../../utils/wxConfig'
const MFooter = () => {
  let [visible, setVisible] = useState(false)
  useEffect(() => {
    init()
  }, [])
  let init = async () => {
    // wxConfig()
    // let res = await jsConfigApi({
    //   url: window.location.href.split('#')[0],
    // })
    // console.log('footer_res', res)
    // window.wx.config({
    //   debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    //   ...res,
    //   jsApiList: [],
    //   openTagList: ['wx-open-launch-weapp'], // 必填，需要使用的JS接口列表
    // })
    // window.wx.ready(() => {
    //   console.log('ready')
    // })

    var btn = document.getElementById('launch-btn')
    btn.addEventListener('launch', function (e) {
      console.log('success')
    })
    btn.addEventListener('error', function (e) {
      console.log('fail', e.detail)
    })
  }
  let goFW = () => {
    window.location.href =
      'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzAwMjc4OTg2Mg==#wechat_redirect'
  }
  return (
    <div className="footer">
      <p>更多物流地产最新资讯与独家干货</p>
      <Footer label="尽在瑞莱博产品与新媒体矩阵"></Footer>
      <DownOutline />
      <div className="link">
        <wx-open-launch-weapp
          id="launch-btn"
          appid="wx3a29dc00b4677290"
          path="modules/wms/views/zone/list/index"
        >
          <script type="text/wxtag-template">
            <div
              style={{
                width: '70px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <img style={{ width: '36px', height: '36px' }} src={ixuanzhiPng} alt="ixuanzhiPng" />
              <p
                style={{
                  fontSize: '8px',
                  fontWeight: '500',
                  color: '#212121',
                  lineHeight: '14px',
                  margin: '0px',
                }}
              >
                选址小程序
              </p>
            </div>
          </script>
        </wx-open-launch-weapp>
        {/* <div className="linkItem">
          <img src={ixuanzhiPng} alt="ixuanzhiPng" />
          <p>选址小程序</p>
        </div> */}
        <Divider direction="vertical" />
        <div className="linkItem" onClick={goFW}>
          <img src={logoPng} alt="logoPng" />
          <p>微信服务号</p>
        </div>
        <Divider direction="vertical" />
        <div
          className="linkItem"
          onClick={() => {
            console.log(1)
            setVisible(true)
            ImageViewer.show({ image: qrcodePng })
          }}
        >
          <img src={qrcodePng} alt="qrcodePng" />
          <p>扫码关注视频号</p>
        </div>
      </div>
      <Footer content="© 2024 瑞莱博 RELIABLE. All rights reserved."></Footer>
    </div>
  )
}

export default MFooter
